// extracted by css-extract-rspack-plugin
var _1 = "omK4L8Hb_yUfWm9t";
var _2 = "Z3G9EkeqlcA8VCGL";
export { _1 as "placeholderBase", _2 as "placeholderIcon" }
